import React from 'react';
import { IconProps } from './types';

const CommitmentTrackerIcon: React.FC<IconProps> = props => {
  const { className, size = '34', fillColor = '#626BFE' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      className={className}
      fill="none"
    >
      <rect width={size} height={size} rx="4" fill={fillColor} />
      <path
        d="M23.8898 18.0298L21.0698 21.3498"
        stroke="white"
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
      <path
        d="M14.7799 20.8198L12.3599 23.6398"
        stroke="white"
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
      <path
        d="M19.0501 21.72L16.8101 20.46"
        stroke="white"
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
      <path
        d="M16.98 19.8102C16.98 20.0502 16.92 20.2702 16.8 20.4602C16.58 20.8702 16.14 21.1502 15.63 21.1502C15.3 21.1502 15.01 21.0402 14.77 20.8202C14.48 20.5802 14.29 20.2202 14.29 19.8102C14.29 19.0702 14.89 18.4702 15.63 18.4702C16.37 18.4702 16.97 19.0702 16.97 19.8102H16.98Z"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.8402 24.6598C12.8402 25.3998 12.2402 25.9998 11.5002 25.9998C10.7602 25.9998 10.1602 25.3998 10.1602 24.6598C10.1602 23.9198 10.7602 23.3198 11.5002 23.3198C11.8302 23.3198 12.1202 23.4298 12.3602 23.6498C12.6502 23.8898 12.8402 24.2498 12.8402 24.6598Z"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.5599 22.3698C21.5599 23.1098 20.9599 23.7098 20.2199 23.7098C19.4799 23.7098 18.8799 23.1098 18.8799 22.3698C18.8799 22.1298 18.9399 21.9098 19.0599 21.7198C19.2799 21.3098 19.7199 21.0298 20.2299 21.0298C20.5499 21.0298 20.8499 21.1398 21.0799 21.3498C21.3799 21.5898 21.5699 21.9498 21.5699 22.3698H21.5599Z"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.9998 16.9298C25.9998 17.6698 25.3998 18.2698 24.6598 18.2698C23.9198 18.2698 23.3198 17.6698 23.3198 16.9298C23.3198 16.6898 23.3798 16.4698 23.4998 16.2798C23.7198 15.8698 24.1598 15.5898 24.6698 15.5898C24.9898 15.5898 25.2898 15.6998 25.5198 15.9098C25.8198 16.1498 26.0098 16.5098 26.0098 16.9298H25.9998Z"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.71 6H6.5C6.22 6 6 6.22 6 6.5V24.16C6 24.43 6.22 24.66 6.5 24.66H7.96C7.96 22.66 9.63 21.03 11.63 21.12L12.17 20.49C12.12 20.26 12.1 20.03 12.1 19.81C12.1 17.85 13.69 16.27 15.64 16.27C17.31 16.27 18.73 17.43 19.09 19.01C19.45 18.89 19.84 18.83 20.21 18.83V6.5C20.21 6.22 19.99 6 19.71 6Z"
        fill="white"
      />
      <path
        d="M13.5398 8.89014V7.89014H8.0498V8.89014H9.8598C10.4098 8.89014 10.8698 9.23014 11.0698 9.71014H8.0498V10.7101H11.0698C10.8698 11.1801 10.4098 11.5101 9.8698 11.5101C9.6798 11.5101 9.4998 11.4701 9.3398 11.4001C9.1198 11.3001 8.8598 11.3601 8.7198 11.5601C8.5798 11.7601 8.5998 12.0301 8.7798 12.2001L11.4898 14.9101L12.1998 14.2001L10.4298 12.4301C11.2698 12.2201 11.9198 11.5501 12.1198 10.7001H13.5498V9.70014H12.1198C12.0598 9.40014 11.9298 9.12014 11.7598 8.88014H13.5398V8.89014Z"
        fill={fillColor}
      />
    </svg>
  );
};

export default CommitmentTrackerIcon;
